import React, { Component } from 'react';
import { ButtonToolbar, Button, FormGroup, FormControl, ControlLabel, Grid, Row, Col, Table, Panel } from 'react-bootstrap';
import Select from "react-select";

import { HandleDialog } from '../../../../HandleDialog';
import { LinesHelper } from '../helpers/LinesHelper';

export class TmlScheduleSet extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isEditing: props.isEditing || false,
            form: Object.assign({
                id: 0,
                line: undefined,
                setOfDayTypes: undefined,
                season: "",
                title: "",
                alternateText: ""
            }, props.value),
            styles: {
                lineInputError: null,
                setOfDayTypesInputError: null,
                seasonInputError: null,
                titleInputError: null,
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        }
    }

    // ------------------------

    onSelectValue(e, property, callback = undefined) {
        const { form } = this.state;

        form[property] = e;

        this.setState({
            form: form
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    onChangeValue(e, property, callback = undefined) {
        const { form } = this.state;

        form[property] = e.target.value;

        this.setState({
            form: form
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    onEdit() {
        this.setState({
            isEditing: true
        });
    }

    onRemove() {
        const { value, lines } = this.props;

        let lineCode = "";
        if (undefined !== lines) {
            lineCode = `${value.line.code} - `;
        }

        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende remover os horários para "[${value.season}] ${lineCode}${value.title} ## ${value.setOfDayTypes.name}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    id: value.id
                }
            }
        });
    }

    onSave() {
        const { form } = this.state;

        if (this.isValidInput(form)) {
            this.props.onSave(form);

            const { value } = this.props;

            if (undefined !== value && null !== value && 0 !== value.id) {
                this.setState({
                    isEditing: false
                });
            }
            else {
                form.line = null;
                form.setOfDayTypes = null;
                form.season = "";
                form.title = "";
                form.alternateText = "";
            }

            this.setState({
                form: form
            });
        }
    }

    onCancel() {
        const { value } = this.props;
        const { form } = this.state;

        form.line = value.line;
        form.setOfDayTypes = value.setOfDayTypes;
        form.title = value.title;
        form.alternateText = value.alternateText;

        this.setState({
            isEditing: false,
            form: form
        });
    }

    // ------------------------

    onExitDialog(isToExecute, argument) {
        if (isToExecute) {
            this.props.onRemove(argument.id);
        }

        this.setState({
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ------------------------

    isValidInput(form) {
        const { lines } = this.props;
        const { styles } = this.state;
        let errors = 0;

        if (undefined !== lines) {
            styles.lineInputError = null;
            if ("" === form.line || null === form.line || undefined === form.line) {
                styles.lineInputError = 'error';
                errors++;
            }
        }

        styles.setOfDayTypesInputError = null;
        if ("" === form.setOfDayTypes || null === form.setOfDayTypes || undefined === form.setOfDayTypes) {
            styles.setOfDayTypesInputError = 'error';
            errors++;
        }

        styles.seasonInputError = null;
        if ("" === form.season || null === form.season || undefined === form.season) {
            styles.seasonInputError = 'error';
            errors++;
        }

        styles.titleInputError = null;
        if ("" === form.title || null === form.title || undefined === form.title) {
            styles.titleInputError = 'error';
            errors++;
        }

        this.setState({
            styles: styles
        });

        return 0 === errors;
    }

    // ------------------------

    renderTopButtons() {
        return (
            <ButtonToolbar className="pull-right">
                <Button onClick={() => this.onEdit()}> EDITAR </Button>
                <Button onClick={() => this.onRemove()}> REMOVER </Button>
            </ButtonToolbar>
        );
    }

    renderCancelButtonAddSet() {
        if(!"function" === typeof(this.props.onCancel)) {
            return null;
        }

        return (
            <Button onClick={() => this.props.onCancel()}> CANCELAR </Button>
        );
    }

    renderBottomButtons() {
        const { value } = this.props;

        if (undefined === value || null === value || 0 === value.id) {
            return (
                <ButtonToolbar className="pull-right">
                    <Button onClick={() => this.onSave()}> ADICIONAR </Button>
                    {this.renderCancelButtonAddSet()}
                </ButtonToolbar>
            );
        }

        return (
            <ButtonToolbar className="pull-right">
                <Button onClick={() => this.onSave()}> GUARDAR </Button>
                <Button onClick={() => this.onCancel()}> CANCELAR </Button>
            </ButtonToolbar>
        );
    }

    renderLinesFormGroup(form, styles) {
        const { lines } = this.props;

        if (undefined === lines) {
            return null;
        }

        return (
            <FormGroup controlId="formSetOfDayTypes" validationState={styles.lineInputError}>
                <Row>
                    <Col sm={3} md={2}>
                        <ControlLabel className="padding-top-10">Linha</ControlLabel>
                    </Col>
                    <Col sm={9} md={10}>
                        <Select className="custom-multiselect"
                            placeholder="Sem Linha selecionada"
                            noOptionsMessage={() => "Sem linhas Configuradas"}
                            onChange={(e) => this.onSelectValue(e, "line")}
                            options={lines}
                            isMulti={false}
                            isClearable={true}
                            isOptionSelected={function (a) {
                                return form.line === a;
                            }}
                            getOptionValue={value => value}
                            getOptionLabel={label => LinesHelper.getName(label)}
                            value={form.line}
                        />
                    </Col>
                </Row>
            </FormGroup>
        );
    }

    renderForm(isEditing) {
        if (!isEditing) {
            return null;
        }

        const { setOfDayTypes, className } = this.props;
        const { form, styles } = this.state;

        return (
            <Grid className={`margin-top-15 margin-bottom-15 ${undefined === className ? "" : className}`} fluid>
                {this.renderLinesFormGroup(form, styles)}

                <FormGroup controlId="formSetOfDayTypes" validationState={styles.setOfDayTypesInputError}>
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Conjunto de Tipos de Dia</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select className="custom-multiselect"
                                placeholder="Sem Conjunto de Tipos de dia selecionado"
                                noOptionsMessage={() => "Sem Conjuntos de Tipos de Dia Configurados"}
                                onChange={(e) => this.onSelectValue(e, "setOfDayTypes")}
                                options={setOfDayTypes}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    return form.setOfDayTypes === a;
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={form.setOfDayTypes}
                            />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="formSeason" validationState={styles.seasonInputError}>
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Época</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <FormControl type="text"
                                value={form.season}
                                onChange={(e) => this.onChangeValue(e, "season")} />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="formTitle" validationState={styles.titleInputError}>
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Título</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <FormControl type="text"
                                value={form.title}
                                onChange={(e) => this.onChangeValue(e, "title")} />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="formAlternateText">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Texto Alternativo</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <FormControl
                                type="text"
                                value={form.alternateText}
                                onChange={(e) => this.onChangeValue(e, "alternateText")} />
                        </Col>
                    </Row>
                </FormGroup>

                <Row>
                    <Col sm={12}>
                        {this.renderBottomButtons()}
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderSchedules(isEditing) {
        if (isEditing) {
            return null;
        }

        const { schedules, value, className } = this.props;

        if (0 === schedules.length) {
            return (
                <Grid fluid className={undefined === className ? "" : className}>
                    <Row className="tml-schedule-set padding-top-7 ">
                        <Col className="tml-schedule-set-daytype">
                            <div className="control-label">
                                {value.setOfDayTypes.name}
                            </div>
                        </Col>
                        <Col className="tml-schedule-set-buttons">
                            {this.renderTopButtons()}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Panel key="noSchedules" className="margin-top-15">
                                <Panel.Heading>
                                    <Panel.Title><b>Atenção</b></Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>Não existem horários associados à linha selecionada para o Conjunto de Tipos de Dia <b>{value.setOfDayTypes.name}</b>.</Panel.Body>
                            </Panel>
                        </Col>
                    </Row>
                </Grid>
            );
        }

        const { edition } = this.props;

        return (
            <Grid fluid className={undefined === className ? "" : className}>
                <Row className="tml-schedule-set padding-top-7 ">
                    <Col className="tml-schedule-set-daytype">
                        <div className="control-label">
                            {value.setOfDayTypes.name}
                        </div>
                    </Col>
                    <Col className="tml-schedule-set-buttons">
                        {this.renderTopButtons()}
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} className="table-small-screens">
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th className="width-70p">Nome</th>
                                    <th className="width-30p">Edição</th>
                                    <th><Button bsSize="small" bsStyle="link" className="pull-right" onClick={() => this.props.onSelectAllSchedules(value.id, schedules)}>SELECIONAR TUDO</Button></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    schedules
                                        .reduce((output, schedule) => {
                                            let currentSchedule = output.find(handledSchedule => handledSchedule.name === schedule.name);
                                            if (undefined === currentSchedule) {
                                                currentSchedule = {
                                                    name: schedule.name,
                                                    planningEditions: []
                                                };
                                                output.push(currentSchedule);
                                            }

                                            currentSchedule.planningEditions.push(edition.getPlanningEditionName(schedule.planningEdition));
                                            return output;
                                        }, [])
                                        .map((schedule, index) =>
                                            <tr key={`sched-${value.name}-${index}`}
                                                className={`busched selectable ${value.schedules.includes(schedule.name) ? "checked" : ""}`}
                                                onClick={() => this.props.onScheduleRowClick(value.id, schedule.name)}>
                                                <td>{schedule.name}</td>
                                                <td colSpan={2}>{schedule.planningEditions.map((schedulePlanningEdition, peIdx) => <span key={peIdx} style={{display: "block"}} >{schedulePlanningEdition}</span>)}</td>
                                            </tr>
                                        )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Grid>
        );
    }

    render() {
        const { isEditing, dialog } = this.state;

        return (
            <div>
                {this.renderForm(isEditing)}
                {this.renderSchedules(isEditing)}

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
